import React from "react"
import { useNavigate } from "react-router-dom"
import { Button } from "../ui/button"

const MarketingBanner = () => {
  const navigate = useNavigate()
  const handleRegisterClick = () => {
    navigate("/5daybusinessbootcamp")
  }

  return (
    <section
      className="relative py-4 px-4 flex justify-center text-center
     bg-[#659E33]"
    >
      <div className="flex flex-wrap items-center justify-center gap-3 leading-snug max-w-[1300px] lg:text-xl text-[#F5F5F7]">
        <span className="italic">
          <span className="font-display font-extrabold">
            {" "}
            Build your coaching business with clarity and confidence -
          </span>{" "}
          Earn 7.5 CCE credit (ICF & NBHWC)
        </span>
        <Button
          variant="outlineDynamic"
          className="bg-[#659E33]"
          style={{ borderColor: "#fff" }}
          onClick={handleRegisterClick}
        >
          <span className="lg:text-xl font-bold font-[#659E33]">
            LEARN MORE
          </span>
        </Button>
      </div>
    </section>
  )
}

export default MarketingBanner
